export default (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.7151" cy="23" r="22.2151" stroke="white" />
        <path
            d="M31.5898 22.1338C32.2565 22.5187 32.2565 23.4809 31.5898 23.8658L19.0273 31.1189C18.3606 31.5037 17.5273 31.0226 17.5273 30.2528L17.5273 15.7468C17.5273 14.977 18.3606 14.4959 19.0273 14.8808L31.5898 22.1338Z"
            fill="white"
        />
    </svg>
)
